import { use } from 'react';

import { PortalUsersContext } from '../context/portal-users-context';

export const usePortalUsers = () => {
   const context = use(PortalUsersContext);

   if (!context) {
      throw new Error('usePortalUsers must be used within a PortalUsersContext');
   }

   return context;
};
